import styled from '@emotion/styled';
import { FC } from 'react';
import { useCityLogo } from '../../hooks';
import placeholder from '../../assets/image-placeholder-w35.jpg';
import _ from 'lodash';
import { colors } from '../../theming/theme';

export interface CityLogoProps {
  cityId: string;
}

const CityImage = styled.img({
  height: '60px',
  width: '60px',
  padding: '3px',
  margin: '0',
  objectFit: 'contain',
  border: 'solid 1px ' + colors.text300,
  borderRadius: '50%',
});

const CityLogo: FC<CityLogoProps> = ({ cityId }) => {
  const uri = useCityLogo(cityId);

  return (
    <CityImage
      alt="Logo comune"
      src={_.isNil(uri) ? placeholder : uri}
      title="Logo comune"
    />
  );
};

export default CityLogo;
